import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveStatsComponent from './js/live-stats.component';
import LiveStatsCard from './js/live-stats-card';
import LiveStatsCardContainer from './js/live-stats-card-container';

ComponentsFactory.getInstance().define('live-stats', LiveStatsComponent);

export * from './js/enums';
export {
    LiveStatsCard,
    LiveStatsCardContainer
};
